__turbopack_context__.v({
  "UiCard": "containers-module__a44POq__UiCard",
  "UiCard__image": "containers-module__a44POq__UiCard__image",
  "UiCard__overlay": "containers-module__a44POq__UiCard__overlay",
  "UiCard__variant__image": "containers-module__a44POq__UiCard__variant__image" + " " + "containers-module__a44POq__UiCard",
  "UiCard__variant__image__darkText": "containers-module__a44POq__UiCard__variant__image__darkText",
  "UiCard__variant__primary": "containers-module__a44POq__UiCard__variant__primary" + " " + "containers-module__a44POq__UiCard",
  "UiCard__variant__secondary": "containers-module__a44POq__UiCard__variant__secondary" + " " + "containers-module__a44POq__UiCard",
  "UiCard__variant__tertiary": "containers-module__a44POq__UiCard__variant__tertiary" + " " + "containers-module__a44POq__UiCard",
});
